export const rae = {
  operation_type_router: "operation_type_rm",
  internet: "internet",
  wireless: "wireless",
  edit_devname_bt: "edit_devname_bt",
  ap_wireless: "wireless",
  APaddr1: "APaddr1",
  APmask1: "APmask1",
  APgateway1: "APgateway1",
  APDAddr1: "APDAddr1",
  APPDAddr1: "APPDAddr1",
};

export default rae;
